<template>
  <!--<div id="indexBox">-->
  <!--<el-container class="wmCloudsWrapper">-->
  <!--<app-header></app-header>-->
  <!--<div id="layoutBoxMail">-->
    <!--<el-container class="wmCloudsContant">-->
      <!--&lt;!&ndash; 邮箱左侧导航 &ndash;&gt;-->
      <!--<app-aside></app-aside>-->
      <!--&lt;!&ndash; 设置左侧导航 &ndash;&gt;-->
      <!--<asideSet style="display:none;"></asideSet>-->
      <el-container>
        <div class="flexbox wmCloudsMain">
          <div class="wmCloudsBox">
            <!-- 操作栏 -->
            <div class="actionBar flexBetween">
              <!-- 左侧 -->
              <div class="actionBarLeft">
                <!-- 转发按钮 -->
                <!--<el-button size="small" style="display:none;">-->
                  <!--<el-tooltip content=this.$i18n.t('wm_lang_21e106') placement="top">-->
                    <!--<i class="icon el-icon-forwarding"></i>-->
                  <!--</el-tooltip>-->
                <!--</el-button>-->
                <!-- 全选按钮 -->
                <el-dropdown @command="checkedCommand" v-show="showToolAllCheck" size="small" class="actionDropdown">
                  <el-button size="small">
                    <el-checkbox v-model="allListCheckBox" @click.native.stop="stopBubble($event)" @change.native="handleAllChecked($event)"></el-checkbox><i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                    <el-dropdown-item command="all">{{$t("wm_lang_html_66eeac")}}</el-dropdown-item>
                    <el-dropdown-item command="reverse">{{$t("wm_lang_html_aab57a")}}</el-dropdown-item>
                    <el-dropdown-item command="not">{{$t("wm_lang_html_6297bc")}}</el-dropdown-item>
                    <el-dropdown-item command="read" divided>{{$t("wm_lang_html_8ad629")}}</el-dropdown-item>
                    <el-dropdown-item command="unread">{{$t("wm_lang_html_894a10")}}</el-dropdown-item>
                    <el-dropdown-item command="star">{{$t("wm_lang_html_2f293a")}}</el-dropdown-item>
                    <el-dropdown-item command="unstar" divided>{{$t("wm_lang_html_5abe91")}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <!-- 返回 -->
                <el-button-group v-show="isNewRead" class="actionBtnGroup">
                  <el-button size="small" @click="newReadBack">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_5f4112")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_5f4112')" placement="top">
                      <i class="icon el-icon-back"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>

                <!-- 撤回 -->
                <el-button-group v-show="moreActionBar && currIsSent && checkedSingleBar" class="ml10 actionBtnGroup">
                  <el-button size="small" @click="mailRecallCheck">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_230505")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_230505')" placement="top">
                      <i class="icon el-icon-recall-new"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>

                <!-- 再次编辑 -->
                <el-button-group v-show="(!isNewRead && checkedSingleBar && moreActionBar && (currIsDraft || currIsSent) && layoutType !== 'tb') || (isNewRead && currIsSent)" class="ml10 actionBtnGroup">
                  <el-button size="small" @click="editAgain">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_ca7b67")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_ca7b67')" placement="top">
                      <i class="icon el-icon-editAgain"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 删除/举报按钮组 （已备份下不显示）-->
                <el-button-group class="ml10 actionBtnGroup" v-show="!isNewRead && (moreActionBar&&!isDeleteFolder&&!isBackupFolder&&!isGarbageFolder) || isNewRead && !(currNewReadIsDelete || currNewReadIsBackup || currNewReadIsGarbage)">
                  <el-dropdown split-button @command="deleteCommand" size="small" class="actionDropdown" @click="deleteCommand('del')">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_2f4aad")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_2f4aad')" placement="top">
                      <i class="icon el-icon-del"></i>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="del">{{$t("wm_lang_html_2f4aad")}}</el-dropdown-item>
                      <el-dropdown-item command="delForever">{{$t("wm_lang_html_96d2b7")}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!--<el-button size="small">-->
                    <!--<el-tooltip content=this.$i18n.t('wm_lang_bff744') placement="top">-->
                      <!--<i class="icon el-icon-report"></i>-->
                    <!--</el-tooltip>-->
                  <!--</el-button>-->
                </el-button-group>
                <el-button-group class="ml10 actionBtnGroup" v-show="!isNewRead && (moreActionBar&&(isDeleteFolder || isGarbageFolder)) || isNewRead && currNewReadIsDelete || isNewRead && currNewReadIsGarbage">
                  <el-button @click="deleteCommand('delForever')" size="small">
                    <span  v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_96d2b7")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_96d2b7')" placement="top">
                      <i class="icon el-icon-del"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 回复/回复全部/转发按钮组 -->
                <el-button-group class="ml10 actionBtnGroup" v-show="!isNewRead && (moreActionBar && !currIsDraft) || isNewRead">
                  <el-button @click="replyMail" size="small" v-show="!isNewRead && (checkedSingleBar && layoutType === 'lr') && !isSentFolder || (isNewRead && !currNewReadIsSent)">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_1edff0")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_1edff0')" placement="top">
                      <i class="icon el-icon-reply"></i>
                    </el-tooltip>
                  </el-button>
                  <el-dropdown  @command="replyCommand" @click="replyCommand('replyAll')" split-button v-show="(checkedSingleBar && layoutType === 'lr') || isNewRead" size="small" class="actionDropdown">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_3a580c")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_3a580c')" placement="top">
                      <i class="icon el-icon-replyAll"></i>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="replyAll">{{$t("wm_lang_html_3a580c")}}</el-dropdown-item>
                      <el-dropdown-item command="replyAllAttach">{{$t("wm_lang_html_2a214e")}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button @click="forwardMail" size="small">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_21e106")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_21e106')" placement="top">
                      <i class="icon el-icon-forwarding"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 移动到/标记为/筛选按钮组 -->
                <el-button-group class="ml10 actionBtnGroup">
                  <el-dropdown split-button @command="moveCommand" size="small" class="actionDropdown" v-show="moreActionBar">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_86ed3d")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_86ed3d')" placement="top">
                      <i class="icon el-icon-filset"></i>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown" class="nice_scroll dropdown-menu-cut">
                      <el-dropdown-item :command="item.folderId" v-for="(item, index) in moveFolders" :key="index">{{item.displayName}}</el-dropdown-item>
                      <!--<el-dropdown-item>{{$t("wm_lang_html_e75969")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_93d159")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_5cc232")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_22b433")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_0bb8f9")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_c3ba16")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item divided>{{$t("wm_lang_html_f3a485")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item>{{$t("wm_lang_html_e4ef4a")}}</el-dropdown-item>-->
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown split-button @command="markCommand" @click="handleClick" size="small" class="actionDropdown" v-show="moreActionBar">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_9989a0")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_9989a0')" placement="top">
                      <i class="icon el-icon-marked"></i>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="read">{{$t("wm_lang_html_3be934")}}</el-dropdown-item>
                      <el-dropdown-item command="unread">{{$t("wm_lang_html_c247ad")}}</el-dropdown-item>
                      <el-dropdown-item command="star" divided>{{$t("wm_lang_html_e4a827")}}</el-dropdown-item>
                      <el-dropdown-item command="unstar">{{$t("wm_lang_html_e0745b")}}</el-dropdown-item>
                      <!--<el-dropdown-item command="deal" divided>{{$t("wm_lang_html_90585c")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item command="dealt">{{$t("wm_lang_html_6785d8")}}</el-dropdown-item>-->
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown split-button v-show="showToolFilter" @command="filterCommand" size="small" class="actionDropdown">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_c2fe62")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_c2fe62')" placement="top">
                      <i class="icon el-icon-filtrate"></i>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown" class="el-dropdown-ej el-dropdown-ej-max126">
                      <el-dropdown-item command="all">{{$t("wm_lang_html_a8b0c2")}}</el-dropdown-item>
                      <el-dropdown-item command="unread">{{$t("wm_lang_html_894a10")}}</el-dropdown-item>
                      <el-dropdown-item command="read">{{$t("wm_lang_html_8ad629")}}</el-dropdown-item>
                      <el-dropdown-item command="reply">{{$t("wm_lang_html_4bea88")}}</el-dropdown-item>
                      <el-dropdown-item command="forward">{{$t("wm_lang_html_973732")}}</el-dropdown-item>
                      <!--<el-dropdown-item v-show="false" command="recallAll">{{$t("wm_lang_html_cdd451")}}</el-dropdown-item>-->
                      <!--<el-dropdown-item v-show="false" command="recallPart">{{$t("wm_lang_html_88866c")}}</el-dropdown-item>-->
                      <el-dropdown-item command="star" divided>{{$t("wm_lang_html_2f293a")}}</el-dropdown-item>
                      <el-dropdown-item command="unstar">{{$t("wm_lang_html_5abe91")}}</el-dropdown-item>
                      <el-dropdown-item>{{$t("wm_lang_html_c360e9")}}<i class="el-icon-arrow-right el-icon--right"></i>
                        <div class="el-dropdown-menu-ej">
                          <ul class="el-dropdown-menu">
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'timeDes'}" @click.stop="filterCommand('timeDes')">{{$t("wm_lang_html_e39b19")}}</li>
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'timeAsc'}" @click.stop="filterCommand('timeAsc')">{{$t("wm_lang_html_3950e5")}}</li>
                            <!--<li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'senderDes'}" @click.stop="filterCommand('senderDes')">{{$t("wm_lang_html_808773")}}</li>-->
                            <!--<li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'senderAsc'}" @click.stop="filterCommand('senderAsc')">{{$t("wm_lang_html_0345b9")}}</li>-->
                            <!--<li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'subjectDes'}" @click.stop="filterCommand('subjectDes')">{{$t("wm_lang_html_ecac25")}}</li>-->
                            <!--<li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'subjectAsc'}" @click.stop="filterCommand('subjectAsc')">{{$t("wm_lang_html_cb8dc2")}}</li>-->
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'sizeDes'}" @click.stop="filterCommand('sizeDes')">{{$t("wm_lang_html_740499")}}</li>
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'sizeAsc'}" @click.stop="filterCommand('sizeAsc')">{{$t("wm_lang_html_ff05d1")}}</li>
                          </ul>
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item command="attach" divided>{{$t("wm_lang_html_69e308")}}</el-dropdown-item>
                      <el-dropdown-item command="noattach">{{$t("wm_lang_html_61a68d")}}</el-dropdown-item>
                      <el-dropdown-item divided>{{$t("wm_lang_html_ee8ecb")}}<i class="el-icon-arrow-right el-icon--right"></i>
                        <div class="el-dropdown-menu-ej">
                          <ul class="el-dropdown-menu">
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'priorityUrgency'}" @click.stop="filterCommand('priorityUrgency')">{{$t("wm_lang_html_cb0ed5")}}</li>
                            <li :class="{'el-dropdown-menu__item':true, 'sortDot': listSortType === 'priorityNormal'}" @click.stop="filterCommand('priorityNormal')">{{$t("wm_lang_html_35242c")}}</li>
                            <!--<li class="el-dropdown-menu__item" @click.stop="filterCommand('prioritySlow')">{{$t("wm_lang_html_1efeae")}}</li>-->
                          </ul>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-button-group>
                <!-- 保存按钮 -->
                <el-button-group v-show="!checkedSingleBar && !isNewRead" class="ml10 actionBtnGroup">
                  <el-button size="small">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon" @click="saveMails">{{$t("wm_lang_html_be5fbb")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" @click.native="saveMails" :content="$i18n.t('wm_lang_be5fbb')" placement="top">
                    <i class="icon el-icon-save"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 不是垃圾邮件按钮 -->
                <el-button-group v-show="(moreActionBar && isGarbageFolder) || currNewReadIsGarbage" class="ml10 actionBtnGroup">
                  <el-button size="small">
                    <span @click="notSpams">{{$t("wm_lang_html_7a2e8b")}}</span>
                    <!--<el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" content=this.$i18n.t('wm_lang_7a2e8b') placement="top">-->
                    <!--<i class="icon el-icon-save"></i>-->
                    <!--</el-tooltip>-->
                  </el-button>
                </el-button-group>
              </div>
              <!-- 右侧 （列表布局时启用）-->
              <!--<div class="actionBarRight flexBetween">-->
                <!--<el-dropdown size="medium" trigger="click" class="mr20">-->
                  <!--<span class="el-dropdown-link">-->
                    <!--1/5页<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  <!--</span>-->
                  <!--<el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">-->
                    <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>2/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>3/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>4/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>5/5</el-dropdown-item>-->
                  <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
                <!--<el-link :underline="false"><i class="el-icon-arrow-left mr10 f18"></i></el-link>-->
                <!--<el-link :underline="false"><i class="el-icon-arrow-right mr10 f18"></i></el-link>-->
              <!--</div>-->
            </div>
            <!-- 设置页面包屑导航 -->
            <setBreadNav style="display:none;"></setBreadNav>

            <!-- 跨页全选 -->
            <div class="listSelectAllBar" v-show="$store.getters.acrossSelectFlag">
              <span v-show="$store.getters.acrossSelectCount === 0">{{$t("wm_lang_html_458e42")}}&nbsp;{{acrossPageSize}}&nbsp;{{$t("wm_lang_html_c228dd")}}<el-link type="primary" class="blue3" :underline="false" @click="acrossSelectAll">{{$t("wm_lang_html_cb0e98")}}&nbsp;{{acrossTotalCount}} {{$t("wm_lang_html_6a3db1")}}</el-link></span>
              <span v-show="$store.getters.acrossSelectCount !== 0">{{$t("wm_lang_html_b8ef0f")}}&nbsp;{{acrossTotalCount}}&nbsp;{{$t("wm_lang_html_c228dd")}}<el-link type="primary" class="blue3" :underline="false" @click="acrossSelectAll">{{$t("wm_lang_html_3149de")}}</el-link></span>
            </div>

            <!-- 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS -->
            <div :class="{'flexbox': true, 'wmCloudsCount': true, 'homeCloudsCount': true, 'homeCloudsBar': $store.getters.acrossSelectFlag}">
              <!-- 邮件列表 -->
              <listBar v-show="$route.name !== 'newRead'"></listBar>
              <!-- view内容区 -->
              <div v-show="layoutType === 'lr' || $route.name === 'newRead'" class="mainBar nice_scroll">
                <transition mode="out-in">
                  <!--<router-view :key="key"></router-view>-->
                  <boxRead></boxRead>
                </transition>
              </div>
            </div>
          </div>
          <!-- 右侧页签 -->
          <!--<tabBar></tabBar>-->
        </div>
        <el-dialog :title="$i18n.t('comm_lang_0026')" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
          <div class="tab_warn"><p>{{$t("comm_lang_0098")}}</p></div>
          <div v-show="recalling"><i class="el-icon-loading"></i>{{$t("comm_lang_0033")}}</div>
          <el-table :data="recallData" :show-header="false" class="nice_scroll" size="mini" style="min-height:200px;overflow: auto;" max-height="400px">
            <el-table-column property="emailName" label="地址"></el-table-column>
            <el-table-column label="撤回结果">
              <template slot-scope="scope">
                <i v-if="scope.row.result" class="el-icon-circle-check"></i>
                <i v-if="!scope.row.result" class="el-icon-warning-outline"></i>
                <span style="margin-left: 10px" :class="scope.row.result ? 'c_green' : 'c_red'">{{ getRecallMessage(scope.row.code) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="recallLengthLimit" class="tc mt20">{{$t("custom_lang_0032")}}</div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">{{$t("wm_lang_html_b15d91")}}</el-button>
          </div>
        </el-dialog>
        <!--<app-footer></app-footer>-->
      </el-container>
    <!--</el-container>-->
  <!--</div>-->
  <!--</el-container>-->
  <!--</div>-->
</template>

<script>
  import Cookies from 'js-cookie';
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'
  import asideSet from '@/components/sub/asideSet.vue'
  import setBreadNav from '@/components/sub/setBreadNav.vue'
  import listBar from '@/components/sub/listBar.vue'
  import tabBar from '@/components/sub/tabBar.vue'
  import setComponent from "@/components/views/setBox/setComponent"
  import boxMail from "@/components/views/layout/boxMail"
  import boxRead from "@/components/views/layout/boxRead"
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { downloadFile, belongRootFolderId } from '@/utils/utils';

  export default {
    // name: 'layoutBoxMail',
    name: 'BoxMail',
    data () {
      return {
        msgindex: this.$i18n.t('wm_lang_8abc56'),
        currentPage2: 5,
        layoutType: '',
        moveFolders: [],
        showToolFilter: true,
        showToolAllCheck: true,
        isNewRead: false,
        configSetting: {},
        currNewReadFolderId: 1,
        listSortType: 'timeDes',
        allListCheckBox: false,
        acrossPageSize: 0,
        acrossPages: 0,
        acrossTotalCount: 0,
        confDisplaySetting: {},
        recallData: [],
        dialogTableVisible: false,
        recalling: true,
        recallLengthLimit: false
      }
    },
    components:{
      setComponent,
      asideSet,
      setBreadNav,
      tabBar,
      listBar,
      boxRead,
      'app-header': AppHeader,
      'app-footer': AppFooter,
      boxMail
    },
    methods: {
      handleAllChecked(e) {
        // console.log(e.target.checked)
        if(e.target.checked) {
          this.checkedCommand('all');
          this.allListCheckBox = true;
        } else {
          this.checkedCommand('not');
        }
      },
      acrossSelectAll() {
        if(this.$store.getters.acrossSelectCount === 0) {
          this.$store.commit('SET_ACROSS_COUNT', this.acrossTotalCount);
        } else {
          this.$store.commit('SET_ACROSS_COUNT', 0);
          this.$store.commit('SET_ACROSS_FLAG', false);
          this.$store.commit('SET_CHECKED_MAILS',[]);
          this.allListCheckBox = false;
        }
      },
      mailRecallCheck() {
          let self = this;
          let mid = this.$route.params.id ? this.$route.params.id : this.$store.getters.checkedMails[0].mailIndexId;
          (function (api, enums, pms) {
            let pm = pms.Index.checkUndoSentMailParamBuilder();
            pm.mailIndexId = mid;
            api.Index.checkUndoSentMail(pm, function (res) {
              const data = res.data;
              console.log(data);
              if(data.code === 0) {
                console.log(mid)
                self.mailRecall(mid);
              } else {
                // self.$alert(self.$i18n.t('comm_lang_0032'), self.$i18n.t('comm_lang_0026'), {
                //   confirmButtonText: self.$i18n.t('wm_lang_b15d91'),
                //   closeOnClickModal: false,
                //   type: 'warning',
                //   callback: action => {
                //     //
                //   }
                // });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
      },
      getRecallMessage(code) {
        let msg = '';
        switch (code) {
          case xmail.enums.UndoSendMailResultCode.WM_SEND_UNDO_MAIL_SUCCESS:
            msg = this.$i18n.t('custom_lang_0075');
            break;
          case xmail.enums.UndoSendMailResultCode.WM_SEND_UNDO_MAIL_DELIVER:
            msg = this.$i18n.t('custom_lang_0076');
            break;
          case xmail.enums.UndoSendMailResultCode.WM_SEND_UNDO_MAIL_DELETE:
            msg = this.$i18n.t('custom_lang_0077');
            break;
          case xmail.enums.UndoSendMailResultCode.WM_SEND_UNDO_MAIL_FOREIGN:
            msg = this.$i18n.t('custom_lang_0078');
            break;
        }
        return msg;
      },
      mailRecall(mid) {
        let recallPeriod = this.configSetting.globalConfig.maximumLimit.undoTimeLimit;
        let recall_unit = parseInt(recallPeriod) < 24 ? parseInt(recallPeriod)+this.$i18n.t('custom_lang_0097') : parseInt(recallPeriod)/24+this.$i18n.t('custom_lang_0098');
        this.$confirm(`<p>${this.$i18n.t('comm_lang_0027')}</p>
          <p style="color:#999999; font-size: 12px">${this.$i18n.t('comm_lang_0028')}</p>
          <p style="color:#999999; font-size: 12px">${this.$i18n.t('comm_lang_0029')}</p>
          <p style="color:#999999; font-size: 12px">${this.$i18n.t('comm_lang_0030')}</p>
          <p style="color:#999999; font-size: 12px">${this.$i18n.t('custom_lang_0096')} ${recall_unit} ${this.$i18n.t('custom_lang_0099')}</p>`, this.$i18n.t('comm_lang_0026'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          customClass: 'recall-tips-box',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          let self = this;
          self.recallLengthLimit = false;
          self.recallData = [];
          self.dialogTableVisible = true;
          self.recalling = true;
          (function (api, enums, pms) {
            let pm = pms.Index.undoSentMailParamBuilder();
            pm.mailIndexId = mid;
            api.Index.undoSentMail(pm, function (res) {
              const data = res.data;
              console.log(data);
              if(data.code === 0) {
                self.recalling = false;
                self.recallData = data.data.undoSentMailInfo;
                if(self.recallData.length > 100) {
                  self.recallData = self.recallData.splice(0,100);
                  self.recallLengthLimit = true;
                }
              } else {
                self.recalling = false;
                self.$message({
                  type: 'warning',
                  message: self.$i18n.t('comm_lang_0035')
                });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          //
        });
        // this.$alert(this.$i18n.t('comm_lang_0032'), this.$i18n.t('comm_lang_0026'), {
        //   confirmButtonText: this.$i18n.t('wm_lang_b15d91'),
        //   closeOnClickModal: false,
        //   type: 'warning',
        //   callback: action => {
        //     //
        //   }
        // });
      },
      newReadBack() {
        // console.log(this.$store.getters.commonTabRoute)
        // this.$router.back();
        let commonTabRoute = this.$store.getters.commonTabRoute;
        this.$router.push({name: commonTabRoute.name});
      },
      notSpams() {
        let mailIds = [];
        if(this.$route.name !== 'newRead') {
          let mails = this.$store.getters.checkedMails;
          mailIds = mails.map(item =>{return item.mailIndexId});
        } else {
          let mid = this.$route.params.id;
          mailIds.push(mid);
        }
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Index.nonGarbageMailParamBuilder();
          pm.mailIndexIds = mailIds;
          api.Index.nonGarbageMail(pm, function (res) {
            if(res.data.code === 0) {
              console.log(res.data);
              self.moveMails(mailIds, xmail.enums.FolderType.RECEIVE_BOX_FOLDER_ID);
              // self.$message({
              //   type: 'success',
              //   message: this.$i18n.t('wm_lang_cd0ed2')
              // })
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      getLayoutType() {
        return Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr';
      },
      forwardMail() {
        let mid = this.$route.params.id;
        // console.log(this.$route);
        // this.$router.push({name: 'write', params: {type: 'forward', mid: mid}});
        if(this.$store.getters.acrossSelectCount !== 0) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_9088d8')+' 20 '+this.$i18n.t('wm_lang_6a3db1')
          });
          return;
        }
        if(this.$store.getters.checkedMails.length > 1) {
          if(this.$route.name === 'newRead') {
            this.$router.push({name: 'write', params: {type: 'forward', mid: mid}});
          } else {
            if(this.$store.getters.checkedMails.length > 20) {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_9088d8')+' 20 '+this.$i18n.t('wm_lang_6a3db1')
              });
              return;
            }
            this.$router.push({name: 'write', params: {type: 'forwardMultiple', mid: mid}});
          }
        } else {
          if(this.layoutType === 'lr') {
            this.$router.push({name: 'write', params: {type: 'forward', mid: mid}});
          } else {
            // console.log(this.$store.getters.checkedMails);
            this.$router.push({name: 'write', params: {type: 'forwardTbSingle', mid: mid}});
          }
        }
      },
      editAgain() {
        // console.log(this.$route.params)
        let mid = this.$route.params.id ? this.$route.params.id : this.$store.getters.checkedMails[0].mailIndexId;
        let fileId = this.$route.params.fileId ? this.$route.params.fileId : this.$store.getters.checkedMails[0].fileId;
        if(this.currIsDraft) {
          this.$router.push({name: 'write', params: {type: 'draft', fileId: fileId, mid: mid}});
        }
        if(this.currIsSent) {
          this.$router.push({name: 'write', params: {type: 'sent', fileId: fileId, mid: mid}});
        }
      },
      replyMail() {
        let mid = this.$route.params.id;
        this.$router.push({name: 'write', params: {type: 'reply', mid: mid}});
      },
      saveMails() {
        const urlParams = storeLocal.get('Pwm-urlParams');
        let mails = this.$store.getters.checkedMails;
        let mailIds = mails.map(item =>{return item.mailIndexId});
        let params = {
          mailIndexIds: mailIds
        };
        let url = '/xmail/wm/v1/mail/mailToStream'+ urlParams;
        downloadFile(url, params);
      },
      // filterSort(command) {
      //   let currFid = this.$store.state.folder.folderId;
      //   this.$EventBus.$emit("filterCurrIndex",{type: command, fid: currFid});
        // switch (command) {
        //   case 'timeAsc':
        //     console.log('timeAsc')
        //     break;
        //   case 'timeDes':
        //     console.log('timeDes')
        //     break;
        //   case 'senderAsc':
        //     console.log('senderAsc')
        //     break;
        //   case 'senderDes':
        //     console.log('senderDes')
        //     break;
        //   case 'subjectAsc':
        //     console.log('subjectAsc')
        //     break;
        //   case 'subjectDes':
        //     console.log('subjectDes')
        //     break;
        //   case 'sizeAsc':
        //     console.log('sizeAsc')
        //     break;
        //   case 'sizeDes':
        //     console.log('sizeDes')
        //     break;
        //   default:
        //     return;
        // }
      // },
      filterCommand(command) {
        let currFid = this.$store.state.folder.folderId;
        this.$EventBus.$emit("filterCurrIndex",{type: command, fid: currFid});
        this.listSortType = command;
        // switch (command) {
        //   case 'all':
        //     console.log('all')
        //     break;
        //   case 'unread':
        //     console.log('unread')
        //     break;
        //   case 'read':
        //     console.log('read')
        //     break;
        //   case 'reply':
        //     console.log('reply')
        //     break;
        //   case 'forward':
        //     console.log('forward')
        //     break;
        //   case 'recallAll':
        //     console.log('recallAll')
        //     break;
        //   case 'recallPart':
        //     console.log('recallPart')
        //     break;
        //   case 'star':
        //     this.$EventBus.$emit("filterCurrIndex",{type: 'star', fid: currFid});
        //     break;
        //   case 'unstar':
        //     this.$EventBus.$emit("filterCurrIndex",{type: 'star', fid: currFid});
        //     break;
        //   default:
        //     return;
        // }
      },
      replyCommand(command) {
        let mid = this.$route.params.id;
        switch (command) {
          case 'replyAll':
            this.$router.push({name: 'write', params: {type: 'replyAll', mid: mid}});
            break;
          case 'replyAllAttach':
            this.$router.push({name: 'write', params: {type: 'replyAllAttach', mid: mid}});
            break;
          default:
            return;
        }
      },
      filterIndexList(type) {
        switch (type) {
          case 'all':
            //
            break;
          case 'reverse':
            //
            break;
          default:
            return;
        }
      },
      selectIndexList(type) {
        let checkedIndex = this.$store.getters.checkedMails;
        let checkedIndexIds = checkedIndex.map(item =>{return item.mailIndexId});
        let indexList = this.$store.getters.indexListData;
        let tempList = [];
        switch (type) {
          case 'all':
            tempList = indexList.map(item =>{return item})
            return tempList;
            break;
          case 'reverse':
            tempList = indexList.filter(item => !checkedIndexIds.includes(item.mailIndexId))
            // tempList = tempList.map(item =>{return item})
            return tempList;
            break;
          case 'read':
            tempList = indexList.filter(item => item.seen === true)
            return tempList;
            break;
          case 'unread':
            tempList = indexList.filter(item => item.seen === false)
            return tempList;
            break;
          case 'star':
            tempList = indexList.filter(item => item.starred === true)
            return tempList;
            break;
          case 'unstar':
            tempList = indexList.filter(item => item.starred === false)
            return tempList;
            break;
          default:
            return;
        }
      },
      moveCommand(command) {
        if(this.$store.getters.acrossSelectCount === 0) {
          let mailIds = '';
          if(this.$route.name !== 'newRead') {
            mailIds = this.$store.getters.checkedMails.map(item =>{return item.mailIndexId});
          } else {
            mailIds = [this.$route.params.id];
          }
          this.moveMails(mailIds, command);
        } else {
          this.moveMailsCondition(this.$store.getters.indexListParams, command);
        }
      },
      markCommand(command) {
        let mails = this.$store.getters.checkedMails;
        switch (command) {
          case 'read':
            this.markStatus(mails, 'read');
            break;
          case 'unread':
            this.markStatus(mails, 'unread');
            break;
          case 'star':
            this.markStatus(mails, 'star');
            break;
          case 'unstar':
            this.markStatus(mails, 'unstar');
            break;
          case 'deal':
            //
            break;
          case 'dealt':
            //
            break;
          default:
            return;
        }
      },
      markStatus(mails, type) {
        let self = this;
        let opType = '';
        let opTypeVal = false;
        let opMsg = '';
        if(type === 'star') {
          opType = xmail.enums.MailStatus.STAR;
          opTypeVal = true;
          opMsg = this.$i18n.t('wm_lang_2f293a')
        }
        if(type === 'unstar') {
          opType = xmail.enums.MailStatus.DE_STAR;
          opTypeVal = false;
          opMsg = this.$i18n.t('wm_lang_f5854e')
        }
        if(type === 'read') {
          opType = xmail.enums.MailStatus.READ;
          opTypeVal = true;
          opMsg = this.$i18n.t('wm_lang_a820f8')
        }
        if(type === 'unread') {
          opType = xmail.enums.MailStatus.UNREAD;
          opTypeVal = false;
          opMsg = this.$i18n.t('wm_lang_f361ce')
        }
        if(this.$store.getters.acrossSelectCount === 0) {
          let mailIds = '';
          if(this.$route.name !== 'newRead') {
            mailIds = mails.map(item =>{return item.mailIndexId});
          } else {
            mailIds = [this.$route.params.id];
          }
          // let markStarMails = mails.map(item =>{return {emailId: item.mailIndexId, folderId: item.folderId}});
          (function (api, enums, pms) {
            let spm = pms.Index.setMailStatusParamBuilder();
            spm.mailIndexIds = mailIds;
            spm.targetMailStatus = opType;
            api.Index.setMailStatus(spm, function (res) {
              if(res.data.code === 0) {
                let indexList = self.$store.getters.indexListData;
                let newList = indexList.map((item) => {
                  if(mailIds.includes(item.mailIndexId)){
                    // console.log(item.mailIndexId)
                    switch (type) {
                      case 'star':
                        item.starred = opTypeVal
                        break;
                      case 'unstar':
                        item.starred = opTypeVal
                        break;
                      case 'read':
                        item.seen = opTypeVal
                        break;
                      case 'unread':
                        item.seen = opTypeVal
                        break;
                      default:
                        return;
                    }
                  }
                  return item
                });
                if(self.$route.name === 'newRead' && (type === 'star' || type === 'unstar')) {
                  self.$EventBus.$emit("refreshMailInfo");
                }
                self.$EventBus.$emit("refreshFolders");
                self.$store.commit('SET_INDEX_DATA',newList);
                self.$message(opMsg);
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          (function (api, enums, pms) {
            let spm = pms.Index.setMailStatusByConditionParamBuilder();
            let filterQueryParam = self.$store.getters.indexListParams;
            if(filterQueryParam.mailIndexQueryParam && Object.keys(filterQueryParam.mailIndexQueryParam).length !== 0) {
              spm.mailIndexQueryParam = filterQueryParam.mailIndexQueryParam;
            }
            if(filterQueryParam.mailIndexFilterParam && Object.keys(filterQueryParam.mailIndexFilterParam).length !== 0) {
              spm.mailIndexFilterParam = filterQueryParam.mailIndexFilterParam;
            }
            if(filterQueryParam.folderId) {
              spm.folderId = filterQueryParam.folderId;
            }
            spm.targetMailStatus = opType;
            api.Index.setMailStatusByCondition(spm, function (res) {
              if(res.data.code === 0) {
                let mailIds = res.data.data.mailIndexIds;
                let indexList = self.$store.getters.indexListData;
                let newList = indexList.map((item) => {
                  if(mailIds.includes(item.mailIndexId)){
                    // console.log(item.mailIndexId)
                    switch (type) {
                      case 'star':
                        item.starred = opTypeVal
                        break;
                      case 'unstar':
                        item.starred = opTypeVal
                        break;
                      case 'read':
                        item.seen = opTypeVal
                        break;
                      case 'unread':
                        item.seen = opTypeVal
                        break;
                      default:
                        return;
                    }
                  }
                  return item
                });
                self.$EventBus.$emit("refreshFolders");
                self.$store.commit('SET_INDEX_DATA',newList);
                self.$message(opMsg);
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }
      },
      /**
       * 移动邮件
       * @param mailIndexIds
       * @param folderId
       */
      moveMails(mailIndexIds, targetFolderId) {
        let self = this;
        // self.$EventBus.$emit("closeTabPage",moveItems);
        // return;
        let folders = this.$store.getters.folders;
        let targetFolder = folders.filter(item => {
          return targetFolderId === item.folderId;
        });
        // console.log(targetFolder)
        // return;
        let loading = this.$loading({text: this.$i18n.t('wm_lang_f8de3d'), target: document.querySelector('.mailAreaBox')});
        (function (api, enums, pms) {
          let mpm = pms.Index.moveMailToFolderParamBuilder();
          mpm.mailIndexIds = mailIndexIds;
          mpm.targetFolderId = targetFolderId;
          api.Index.moveMailToFolder(mpm, function (res) {
            if(res.data.code === 0) {
              self.$message(`${self.$i18n.t('custom_lang_0074')}${targetFolder[0].displayName}`);
              self.$store.commit('SET_CHECKED_MAILS',[]);
              self.$router.push({path:'/home/mail'});
              // self.$EventBus.$emit("getCurrFid",{folderId: self.$store.getters.folderId});
              self.$EventBus.$emit("getCurrFid",{keepParams: true});
              self.$EventBus.$emit("closeTabPage",mailIndexIds);
              self.$EventBus.$emit("refreshFolders");
            }
            loading.close();
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      /**
       * 按索引查询结果移动邮件
       * @param filterQueryParam
       * @param folderId
       * @param targetFolderId
       */
      moveMailsCondition(filterQueryParam, targetFolderId) {
        // console.log(filterQueryParam);
        // return;
        let self = this;
        // self.$EventBus.$emit("closeTabPage",moveItems);
        // return;
        let folders = this.$store.getters.folders;
        let targetFolder = folders.filter(item => {
          return targetFolderId === item.folderId;
        });
        // console.log(targetFolder)
        // return;
        let loading = this.$loading({text: this.$i18n.t('wm_lang_58ccec'), target: document.querySelector('.mailAreaBox')});
        (function (api, enums, pms) {
          let mpm = pms.Index.moveMailByConditionParamBuilder();
          if(filterQueryParam.mailIndexQueryParam && Object.keys(filterQueryParam.mailIndexQueryParam).length !== 0) {
            mpm.mailIndexQueryParam = filterQueryParam.mailIndexQueryParam;
          }
          if(filterQueryParam.mailIndexFilterParam && Object.keys(filterQueryParam.mailIndexFilterParam).length !== 0) {
            mpm.mailIndexFilterParam = filterQueryParam.mailIndexFilterParam;
          }
          if(filterQueryParam.folderId) {
            mpm.folderId = filterQueryParam.folderId;
          }
          mpm.targetFolderId = targetFolderId;
          api.Index.moveMailByCondition(mpm, function (res) {
            if(res.data.code === 0) {
              self.$message(`${self.$i18n.t('custom_lang_0074')}${targetFolder[0].displayName}`);
              self.$store.commit('SET_CHECKED_MAILS',[]);
              self.$router.push({path:'/home/mail'});
              // self.$EventBus.$emit("getCurrFid",{folderId: self.$store.getters.folderId});
              self.$EventBus.$emit("getCurrFid",{keepParams: true});
              self.$store.commit('SET_ACROSS_COUNT',0);
              self.$store.commit('SET_ACROSS_FLAG',false);
              self.$EventBus.$emit("closeTabPage",res.data.data.mailIndexIds);
              self.$EventBus.$emit("refreshFolders");
            }
            loading.close();
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      /**
       * 删除邮件
       * @param delItems
       */
      deleteMails(delItems) {
        // console.log(delItems)
        let self = this;
        let loading = this.$loading({text: this.$i18n.t('wm_lang_f8de3d')});
        this.$confirm(this.$i18n.t('wm_lang_61f562')+', '+this.$i18n.t('wm_lang_2b45e2')+'?', this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          (function (api, enums, pms) {
            let dpm = pms.Index.deleteMailParamBuilder();
            dpm.mailIndexIds = delItems;
            api.Index.deleteMail(dpm, function (res) {
              if(res.data.code === 0) {
                self.$store.commit('SET_CHECKED_MAILS',[]);
                // self.$EventBus.$emit("getCurrFid",{folderId: self.$store.getters.folderId});
                self.$EventBus.$emit("getCurrFid",{keepParams: true});
                self.$EventBus.$emit("closeTabPage",delItems);
                self.$EventBus.$emit("refreshFolders");
                self.$router.push({path:'/home/mail'});
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_0007d1')+'!'
                });
              }
              loading.close();
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          loading.close();
        });
      },
      /**
       * 按索引查询结果删除邮件
       * @param filterQueryParam
       */
      deleteMailsCondition(filterQueryParam) {
        // console.log(delItems)
        let self = this;
        let loading = this.$loading({text: this.$i18n.t('wm_lang_f8de3d')});
        this.$confirm(this.$i18n.t('wm_lang_61f562')+', '+this.$i18n.t('wm_lang_2b45e2')+'?', this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          (function (api, enums, pms) {
            let dpm = pms.Index.deleteMailByConditionParamBuilder();
            if(filterQueryParam.mailIndexQueryParam && Object.keys(filterQueryParam.mailIndexQueryParam).length !== 0) {
              dpm.mailIndexQueryParam = filterQueryParam.mailIndexQueryParam;
            }
            if(filterQueryParam.mailIndexFilterParam && Object.keys(filterQueryParam.mailIndexFilterParam).length !== 0) {
              dpm.mailIndexFilterParam = filterQueryParam.mailIndexFilterParam;
            }
            if(filterQueryParam.folderId) {
              dpm.folderId = filterQueryParam.folderId;
            }
            api.Index.deleteMailByCondition(dpm, function (res) {
              if(res.data.code === 0) {
                self.$store.commit('SET_CHECKED_MAILS',[]);
                self.$store.commit('SET_ACROSS_COUNT',0);
                self.$store.commit('SET_ACROSS_FLAG',false);
                // self.$EventBus.$emit("getCurrFid",{folderId: self.$store.getters.folderId});
                self.$EventBus.$emit("getCurrFid",{keepParams: true});
                self.$EventBus.$emit("closeTabPage",res.data.data.mailIndexIds);
                self.$EventBus.$emit("refreshFolders");
                self.$router.push({path:'/home/mail'});
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_0007d1')+'!'
                });
              }
              loading.close();
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          loading.close();
        });
      },
      deleteCommand(command) {
        if(this.$store.getters.acrossSelectCount === 0) {
          switch (command) {
            case 'del':
              let delMails = this.$store.getters.checkedMails;
              if(this.$route.name !== 'newRead') {
                delMails = delMails.map(item =>{return item.mailIndexId});
              } else {
                delMails = [this.$route.params.id];
              }
              this.moveMails(delMails, xmail.enums.FolderType.GARBAGE_BOX_FOLDER_ID);
              break;
            case 'delForever':
              let delForeverMails = this.$store.getters.checkedMails;
              if(this.$route.name !== 'newRead') {
                delForeverMails = delForeverMails.map(item =>{return item.mailIndexId});
              } else {
                delForeverMails = [this.$route.params.id];
              }
              this.deleteMails(delForeverMails);
              break;
            default:
              return;
          }
        } else {
          switch (command) {
            case 'del':
              this.moveMailsCondition(this.$store.getters.indexListParams, xmail.enums.FolderType.GARBAGE_BOX_FOLDER_ID);
              break;
            case 'delForever':
              this.deleteMailsCondition(this.$store.getters.indexListParams);
              break;
            default:
              return;
          }
        }
      },
      stopBubble(e) {
        e.stopPropagation();
      },
      checkedCommand(command) {
        switch (command) {
          case 'all':
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('all'));
                break;
          case 'reverse':
            // console.log(this.selectIndexList('reverse'))
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('reverse'));
                break;
          case 'not':
            this.$store.commit('SET_CHECKED_MAILS',[])
            break;
          case 'read':
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('read'));
            break;
          case 'unread':
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('unread'));
            break;
          case 'star':
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('star'));
            break;
          case 'unstar':
            this.$store.commit('SET_CHECKED_MAILS',this.selectIndexList('unstar'));
            break;
          default:
          return;
        }
        if(this.acrossPages > 1) {
          if(this.$store.getters.checkedMails.length === this.configSetting.displaySetting.pageSize) {
            this.allListCheckBox = true;
            this.$store.commit('SET_ACROSS_FLAG', this.acrossPages > 1);
          } else {
            this.allListCheckBox = false;
            this.$store.commit('SET_ACROSS_FLAG', false);
          }
        } else {
          this.allListCheckBox = this.$store.getters.indexListData.length === this.$store.getters.checkedMails.length;
        }
        // console.log(this.$store.getters.indexListData)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
    },
    mounted(){
      // let allFolders = this.$store.getters.folders;
      // let allFolders = [];
      this.layoutType = Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr';
      this.moveFolders = this.$store.getters.folders;
      if(this.moveFolders.length <= 0) {
        let self = this;
        (function (api, enums, pms) {
          api.Folder.getFolderList({}, function (res) {
            if(res.data.code === 0) {
              let allFolders = res.data.data.mailFolders;
              allFolders = allFolders.filter(item => item.folderId !== enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== enums.FolderType.WAITING_BOX_FOLDER_ID && item.folderId !== enums.FolderType.BACKUP_BOX_FOLDER_ID);
              self.moveFolders = allFolders;
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      } else {
        this.moveFolders = this.moveFolders.filter(item => item.folderId !== xmail.enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== xmail.enums.FolderType.WAITING_BOX_FOLDER_ID && item.folderId !== xmail.enums.FolderType.BACKUP_BOX_FOLDER_ID);
      }

      /*
      更新布局设置
      */
      let self = this;
      this.$EventBus.$off("changeMailLayoutSet");
      this.$EventBus.$on("changeMailLayoutSet",function(data){
        // console.log(data)
        self.layoutType = data.layout;
      });
      this.$EventBus.$off("resetListSortType");
      this.$EventBus.$on("resetListSortType",function(data){
        // console.log(data)
        self.listSortType = 'timeDes';
      });
      this.$EventBus.$off("listCheckAll");
      this.$EventBus.$on("listCheckAll",function(data){
        self.allListCheckBox = !!data;
      });
      this.$EventBus.$off("cancelListCheckAll");
      this.$EventBus.$on("cancelListCheckAll",function(data){
        self.allListCheckBox = !!data;
        self.$store.commit('SET_ACROSS_FLAG', !!data);
      });
      this.$EventBus.$off("setAcrossPageData");
      this.$EventBus.$on("setAcrossPageData",function(data){
        self.acrossPageSize = data.pageSize;
        self.acrossPages = data.pages;
        self.acrossTotalCount = data.total;
      });
      this.configSetting = storeLocal.get('Pwm-configSetting');
      this.confDisplaySetting = this.configSetting.displaySetting;
      //初始化工具栏时的路由监听(从写信、通讯录和首页切换页签的情况)
      if(this.$route.name === 'newRead') {
        this.showToolFilter = false;
        this.showToolAllCheck = false;
        this.isNewRead = true;
        this.currNewReadFolderId = this.$route.params.folderId;
      } else {
        this.showToolFilter = true;
        this.showToolAllCheck = true;
        this.isNewRead = false;
      }
    },
    computed: {
      isDeleteFolder() {
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return storeRootFolderId === xmail.enums.FolderType.GARBAGE_BOX_FOLDER_ID
      },
      isBackupFolder() {
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return storeRootFolderId === xmail.enums.FolderType.BACKUP_BOX_FOLDER_ID
      },
      isSentFolder() {
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return storeRootFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID
      },
      isGarbageFolder() {
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return storeRootFolderId === xmail.enums.FolderType.GARBAGE_MAIL_BOX_FOLDER_ID
      },
      currNewReadIsDelete() {
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.GARBAGE_BOX_FOLDER_ID
      },
      currNewReadIsBackup() {
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.BACKUP_BOX_FOLDER_ID
      },
      currNewReadIsSent() {
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID
      },
      currNewReadIsGarbage() {
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.GARBAGE_MAIL_BOX_FOLDER_ID
      },
      checkedSingleBar() {
        return this.$store.getters.checkedMails.length < 2
      },
      moreActionBar() {
        return this.$route.name === 'newRead' || this.$store.getters.checkedMails.length > 0
      },
      currIsDraft() {
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID || storeRootFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID
        // return this.currNewReadFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID || this.$store.getters.folderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID
      },
      currIsSent() {
        // console.log(this.currNewReadFolderId);
        // console.log(this.$store.getters.folderId);
        // console.log(this.isNewRead);
        let currNewReadRootFolderId = belongRootFolderId(this.currNewReadFolderId, this.$store.getters.folders);
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        return this.isNewRead && currNewReadRootFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID || storeRootFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID
        // return this.currNewReadFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID || this.$store.getters.folderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID
      },
      key() { //路由变化后读信组件自动刷新
        return this.$route.name !== undefined ? this.$route.name + new Date(): this.$route +new Date()
      }
    },
    watch: {
      $route(to, from) {
        // console.log(to);
        // console.log(from);
        //工具栏按钮显示
        if(to.name === 'newRead'){
          this.showToolFilter = false;
          this.showToolAllCheck = false;
          this.isNewRead = true;
          this.currNewReadFolderId = to.params.folderId;
        } else {
          this.showToolFilter = true;
          this.showToolAllCheck = true;
          this.isNewRead = false;
        }
      }
    }
  }
</script>

<style scoped>
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/layout/boxMail.vue